/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { OrganisationVerticalSettingFragmentDoc, QuoteVerticalSettingFragmentDoc } from '../../verticals/form-fields/VerticalsFormField.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationQuoteSettingsForm_DefaultsFragment = { __typename: 'OrganisationDefaults', id: string, defaultMaterialMargin: number, defaultContractType: Types.ContractType, defaultQuoteIsBinding: boolean, defaultQuoteValidityDuration: number, defaultQuoteShowOfferConditions: boolean, defaultQuoteMaterialPriceHandling: Types.QuoteMaterialPriceHandling, defaultMaterialMarginRanges: Array<{ __typename: 'QuoteMaterialMarginRange', priceFrom: number, priceTo: number, materialMargin: number }>, defaultVerticalSettings: Array<{ __typename: 'OrganisationVerticalSetting', id: string, vertical: Types.Vertical, averageWorkBuyingPrice: number, averageWorkSellingPrice: number }> };

export type OrganisationQuoteSettingsForm_ModifyOrganisationDefaultsMutationVariables = Types.Exact<{
  input: Types.OrganisationDefaultsUpdateInput;
}>;


export type OrganisationQuoteSettingsForm_ModifyOrganisationDefaultsMutation = { updateOrganisationDefaults: { __typename: 'OrganisationDefaultsUpdateResult', organisationDefaults: { __typename: 'OrganisationDefaults', id: string, defaultMaterialMargin: number, defaultContractType: Types.ContractType, defaultQuoteIsBinding: boolean, defaultQuoteValidityDuration: number, defaultQuoteShowOfferConditions: boolean, defaultQuoteMaterialPriceHandling: Types.QuoteMaterialPriceHandling, defaultMaterialMarginRanges: Array<{ __typename: 'QuoteMaterialMarginRange', priceFrom: number, priceTo: number, materialMargin: number }>, defaultVerticalSettings: Array<{ __typename: 'OrganisationVerticalSetting', id: string, vertical: Types.Vertical, averageWorkBuyingPrice: number, averageWorkSellingPrice: number }> } } };

export const OrganisationQuoteSettingsForm_DefaultsFragmentDoc = gql`
    fragment OrganisationQuoteSettingsForm_Defaults on OrganisationDefaults {
  id
  defaultMaterialMargin
  defaultMaterialMarginRanges {
    priceFrom
    priceTo
    materialMargin
  }
  defaultContractType
  defaultQuoteIsBinding
  defaultQuoteValidityDuration
  defaultQuoteShowOfferConditions
  defaultQuoteMaterialPriceHandling
  defaultVerticalSettings {
    id
    ...OrganisationVerticalSetting
  }
}
    ${OrganisationVerticalSettingFragmentDoc}`;
export const OrganisationQuoteSettingsForm_ModifyOrganisationDefaultsDocument = gql`
    mutation OrganisationQuoteSettingsForm_ModifyOrganisationDefaults($input: OrganisationDefaultsUpdateInput!) {
  updateOrganisationDefaults(input: $input) {
    organisationDefaults {
      id
      ...OrganisationQuoteSettingsForm_Defaults
    }
  }
}
    ${OrganisationQuoteSettingsForm_DefaultsFragmentDoc}`;
export type OrganisationQuoteSettingsForm_ModifyOrganisationDefaultsMutationFn = Apollo.MutationFunction<OrganisationQuoteSettingsForm_ModifyOrganisationDefaultsMutation, OrganisationQuoteSettingsForm_ModifyOrganisationDefaultsMutationVariables>;

/**
 * __useOrganisationQuoteSettingsForm_ModifyOrganisationDefaultsMutation__
 *
 * To run a mutation, you first call `useOrganisationQuoteSettingsForm_ModifyOrganisationDefaultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationQuoteSettingsForm_ModifyOrganisationDefaultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationQuoteSettingsFormModifyOrganisationDefaultsMutation, { data, loading, error }] = useOrganisationQuoteSettingsForm_ModifyOrganisationDefaultsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationQuoteSettingsForm_ModifyOrganisationDefaultsMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationQuoteSettingsForm_ModifyOrganisationDefaultsMutation, OrganisationQuoteSettingsForm_ModifyOrganisationDefaultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationQuoteSettingsForm_ModifyOrganisationDefaultsMutation, OrganisationQuoteSettingsForm_ModifyOrganisationDefaultsMutationVariables>(OrganisationQuoteSettingsForm_ModifyOrganisationDefaultsDocument, options);
      }
export type OrganisationQuoteSettingsForm_ModifyOrganisationDefaultsMutationHookResult = ReturnType<typeof useOrganisationQuoteSettingsForm_ModifyOrganisationDefaultsMutation>;
export type OrganisationQuoteSettingsForm_ModifyOrganisationDefaultsMutationResult = Apollo.MutationResult<OrganisationQuoteSettingsForm_ModifyOrganisationDefaultsMutation>;
export type OrganisationQuoteSettingsForm_ModifyOrganisationDefaultsMutationOptions = Apollo.BaseMutationOptions<OrganisationQuoteSettingsForm_ModifyOrganisationDefaultsMutation, OrganisationQuoteSettingsForm_ModifyOrganisationDefaultsMutationVariables>;